module.exports = __webpack_public_path__ + "media/fonts/Oricons-342ecfa77edfd269012064854a2fe14b.svg";